import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import PopoverMenu from '@alphapoint/apex-web/lib/components/common/PopoverMenu/PopoverMenu';
import APIcon from '@alphapoint/apex-web/lib/components/common/APIcon';
import { getBEMClasses } from '@alphapoint/apex-web/lib/helpers/cssClassesHelper';

import '@alphapoint/apex-web/lib/components/UserSummary/UserSummaryComponent.css';

class UserSummary extends React.Component {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    history: PropTypes.object,
    settingsRoute: PropTypes.string,
    activityRoute: PropTypes.string,
  };

  static defaultProps = {
    settingsRoute: '',
  };

  handleLogout = () => {
    this.props.history.push('/login');
    this.props.logout();
  };

  renderMenuItems = () => {
    const { t, history, settingsRoute } = this.props;
    let menuItems = [];

    if (settingsRoute) {
      menuItems.push({
        label: t('Settings'),
        onClick: () => history.push(settingsRoute),
      });
    }

    menuItems.push({ divider: true }, { label: t('Sign Out'), onClick: this.handleLogout });

    return menuItems;
  };

  render() {
    const { customClass } = this.props;
    const bemClasses = getBEMClasses(['user-summary-dropdown', customClass]);

    return (
      <div className={bemClasses('container')}>
        <PopoverMenu
          customClass={bemClasses()}
          popoverProps={{
            trigger: (props) => (
              <button className={bemClasses('popover-menu-trigger')} {...props}>
                <APIcon name="profile" customClass={bemClasses('icon')} />
              </button>
            ),
            customClass: 'user-summary',
          }}
          items={this.renderMenuItems()}
        />
      </div>
    );
  }
}

export default withTranslation()(UserSummary);
